export const MY_SAMPLE='mySample';
export const MY_SAMPLE2='mySample2';

export const GET_ITEM_LIST='getItemList';
export const ADD_ITEM_TO_CART = 'addItemToCart'
export const UPDATE_ITEM_QUANTITY = 'updateItemQuantity'
export const CUSTOMER_META_DATA ='customerMetaData'